import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=2dfd5f96&scoped=true&"
import script from "./logout.vue?vue&type=script&lang=js&"
export * from "./logout.vue?vue&type=script&lang=js&"
import style0 from "./logout.vue?vue&type=style&index=0&id=2dfd5f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd5f96",
  null
  
)

export default component.exports